export const blogs = [
  {
    slug: "best-digital-album-app-for-photographers",
    title: "Best Digital Album App for Photographers",
    category: "Photography",
    readTime: "5 min",
    description: "Our Memories helps photographers create and share digital albums, flipbooks, and client event memories with a clean mobile experience.",
    sections: [
      { heading: "Why photographers need digital albums", body: "Clients today expect fast, beautiful, and mobile-friendly delivery. A digital album helps photographers present wedding, birthday, anniversary, and event photos professionally." },
      { heading: "How Our Memories helps", body: "Our Memories makes it easier to organize event photos, create digital albums, build flipbook-style experiences, and share albums with clients." },
      { heading: "Best use cases", body: "Photographers can use Our Memories for wedding previews, birthday memories, anniversary collections, client albums, portfolio sharing, and family event galleries." }
    ],
  },
  {
    slug: "best-wedding-album-app",
    title: "Best Wedding Album App for Couples and Photographers",
    category: "Wedding",
    readTime: "4 min",
    description: "Create and share wedding memories with Our Memories, a digital wedding album and flipbook app.",
    sections: [
      { heading: "Wedding memories deserve a premium experience", body: "Wedding photos are special, and users want a beautiful way to view and share them anytime from their phone." },
      { heading: "Create wedding flipbooks", body: "With Our Memories, wedding photos can be organized into a digital album and shared as a modern flipbook-style experience." },
      { heading: "Helpful for photographers", body: "Photographers can use Our Memories to deliver wedding albums to clients in a clean, mobile-first format." }
    ],
  },
  {
    slug: "how-to-create-digital-flipbook-album",
    title: "How to Create a Digital Flipbook Album",
    category: "Tutorial",
    readTime: "6 min",
    description: "Learn how to create a digital flipbook album for weddings, birthdays, events, and photo studio clients.",
    sections: [
      { heading: "What is a digital flipbook album?", body: "A digital flipbook album turns photos into an interactive viewing experience that feels more premium than a normal gallery." },
      { heading: "Step 1: Install Our Memories", body: "Download Our Memories from Google Play or the App Store and open the app on your phone." },
      { heading: "Step 2: Create an album", body: "Create a new album for your event, upload photos, organize them, and share the final album." }
    ],
  },
  {
    slug: "digital-guest-book-app-for-events",
    title: "Digital Guest Book App for Events",
    category: "Events",
    readTime: "4 min",
    description: "Our Memories helps users create digital guest books and event memory albums for weddings, birthdays, and celebrations.",
    sections: [
      { heading: "Why use a digital guest book?", body: "A digital guest book gives events a modern way to collect and present memories, messages, and photo moments." },
      { heading: "Best events for guest books", body: "Digital guest books are useful for weddings, birthdays, anniversaries, family functions, studio events, and community programs." },
      { heading: "Share memories easily", body: "Users can organize and share memories through a beautiful digital experience instead of scattered folders." }
    ],
  },
  {
    slug: "photo-album-app-for-photo-studios",
    title: "Photo Album App for Photo Studio Owners",
    category: "Studios",
    readTime: "5 min",
    description: "Our Memories is a digital photo album app designed for photo studios, photographers, and event professionals.",
    sections: [
      { heading: "Modern delivery for photo studios", body: "Photo studio clients expect fast previews, simple sharing, and professional presentation." },
      { heading: "Use it for client albums", body: "Studios can use Our Memories for weddings, birthdays, anniversaries, portfolios, and client photo collections." },
      { heading: "Grow your studio brand", body: "Using modern digital tools can help a photo studio appear more professional and attract more clients." }
    ],
  },
];
